// frontend/src/components/ui/Toaster.tsx
// Pila de avisos animados (ver lib/toast.ts). Se monta una sola vez en App.
// Va arriba, debajo de la TopAppBar: abajo taparía los botones de los sheets,
// que es desde donde salen la mayoría de las validaciones.

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, m } from 'motion/react';
import { CheckCircle2, Info, XCircle } from 'lucide-react';
import { cerrarToast, suscribirToasts, type Toast, type TipoToast } from '../../lib/toast';
import { DUR, EASE_IOS, EASE_SALIDA, SPRING } from '../../lib/motion';

const ICONO: Record<TipoToast, { Icon: typeof Info; color: string }> = {
  success: { Icon: CheckCircle2, color: '#34C759' },
  error: { Icon: XCircle, color: '#ff6b6b' },
  info: { Icon: Info, color: '#8ab4f8' },
};

export function Toaster() {
  const [lista, setLista] = useState<Toast[]>([]);
  useEffect(() => suscribirToasts(setLista), []);

  return createPortal(
    <div
      className="fixed inset-x-0 z-[10000] flex flex-col items-center gap-2 px-4 pointer-events-none"
      style={{ top: 'calc(env(safe-area-inset-top) + 72px)' }}
      aria-live="polite"
      role="status"
    >
      <AnimatePresence initial={false}>
        {lista.map((t) => {
          const { Icon, color } = ICONO[t.tipo];
          return (
            <m.button
              key={t.id}
              type="button"
              layout
              onClick={() => cerrarToast(t.id)}
              initial={{ opacity: 0, y: -16, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1, transition: { ...SPRING } }}
              exit={{ opacity: 0, scale: 0.96, transition: { duration: DUR.rapida, ease: EASE_SALIDA } }}
              transition={{ layout: { duration: DUR.base, ease: EASE_IOS } }}
              className="pointer-events-auto w-full max-w-md flex items-start gap-2.5 text-left rounded-2xl px-4 py-3 shadow-[0_8px_24px_rgba(0,0,0,0.22)]"
              style={{
                backgroundColor: 'var(--color-sgcc-inverse-surface, #1c1c1e)',
                color: 'var(--color-sgcc-inverse-on-surface, #f2f2f7)',
              }}
            >
              <Icon size={18} className="flex-shrink-0 mt-px" style={{ color }} />
              <span className="text-[13.5px] font-medium leading-snug whitespace-pre-line">{t.mensaje}</span>
            </m.button>
          );
        })}
      </AnimatePresence>
    </div>,
    document.body,
  );
}
